import React from 'react';
import { useAppSelector } from '@app/hooks';
import { ObjectModel } from '@types';
import { selectHasCurrentProduct } from '@modules/quotation';
import { ModelDetails } from './model-details';
import { NonCadDetails } from './non-cad-details';
import { ProductDetails } from './product-details';

interface ModelDetailsHandlerProps {
    model: ObjectModel;
}

export const DetailsHandler: React.FC<ModelDetailsHandlerProps> = ({ model, children }) => {
    const hasCurrentProduct = useAppSelector(selectHasCurrentProduct);

    return (
        <>
            {model.is_processable && hasCurrentProduct && <ProductDetails model={model} />}
            {model.is_processable && !hasCurrentProduct && <ModelDetails model={model} />}
            {!model.is_processable && <NonCadDetails model={model} />}
        </>
    );
};
